export const base_url = process.env.REACT_APP_BASE_URL;
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL;
export const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
if (process.env.NODE_ENV === "development" && !WEATHER_API_KEY) {
  console.error(
    "REACT_APP_WEATHER_API_KEY is missing. Weather widget will be hidden.",
  );
}
// Universal / App Links — self-hosted on gigmiapp.com (replaces Firebase Dynamic Links, GIG-25).
export const deep_link_base = "https://gigmiapp.com";

// Store listings. Android ships as com.gigmi.app — `com.gigmi` was permanently
// retired with the old Play developer account and can never be published again.
// iOS keeps its original bundle id. Import these rather than hardcoding a store
// URL: the previous package rename had to touch seven files to change one value.
export const android_package_name = "com.gigmi.app";
export const play_store_url = `https://play.google.com/store/apps/details?id=${android_package_name}`;
export const app_store_url =
  "https://apps.apple.com/us/app/gigmi-contractor-revolution/id1604625082";
// Two Google keys, because one cannot serve both call types. The Maps JavaScript
// API is loaded by the browser and is restricted by HTTP referer; the Geocoding
// *web service* rejects referer-restricted keys outright ("API keys with referer
// restrictions cannot be used with this API"), so it needs a key with no
// application restriction, contained instead by its API restriction and quota.
export const google_map_api_key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const google_geocoding_api_key =
  process.env.REACT_APP_GOOGLE_GEOCODING_API_KEY;
export const aero_pay_environment = process.env.REACT_APP_AERO_PAY_ENVIRONMENT;
export const consumer_id = process.env.REACT_APP_CONSUMER_ID;
// Stripe publishable key — safe in the client bundle (the secret key stays server-side).
export const stripe_publishable_key =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
